export class SearchSuggestionPayload {
  public str: string;
  public lang: string;
  public lat: number;
  public lon: number;
  public companyId: number;
  public objective: string;
}



// WEBPACK FOOTER //
// ./src/app/services/search/payload/search-suggestion-payload.ts